<template>
  <div class="about">
    <header>
      <h1 class="logo">
        <img src="./../assets/logo_mai_large.svg" alt="100mai" />
      </h1>
      <a href="/home">100maiへ移動</a>
    </header>
    <main>
      <div class="holder">
        <div class="scroll">
          <section class="item">
            <div>
              <h2 class="title">100maiについて</h2>
            </div>
            <div class="index">
              <ul>
                <li><a href="#login">ログイン/登録</a></li>
                <li><a href="#home">ホーム</a></li>
                <ul class="drop">
                  <li><a href="#home_challengesList">チャレンジリスト</a></li>
                  <ul class="drop">
                    <li><a href="#rebase">チャレンジ設定</a></li>
                  </ul>
                  <li><a href="#home_albumsList">アルバムリスト</a></li>
                  <li><a href="#home_cheersLst">応援リスト</a></li>
                </ul>
                <li><a href="#cheer">応援する</a></li>
                <li><a href="#setting">設定</a></li>
                <ul class="drop">
                  <li><a href="#setting_profile">プロフィール設定</a></li>
                  <li><a href="#setting_account">アカウント設定</a></li>
                </ul>
                <li><a href="#coin-mai">アプリ内通貨「mai」</a></li>
                <li>
                  <a href="#character-mai"
                    >公式キャラクター「mai<span class="super">001</span>」</a
                  >
                </li>
                <li><a href="#news">更新情報</a></li>
                <li><a href="#contact">お問い合わせ</a></li>
              </ul>
            </div>
          </section>
          <section class="item">
            <div>
              <h2 class="title" id="login">
                <a href="#login">ログイン/登録</a>
              </h2>
            </div>
            <div class="content">
              <p>「100mai」では現在</p>
              <ul>
                <li>Twitterアカウントによるログイン</li>
                <li>Googleアカウントによるログイン</li>
              </ul>
              <p>をサポートしています。</p>
            </div>
          </section>
          <section class="item">
            <div>
              <h2 class="title" id="home"><a href="#home">ホーム</a></h2>
            </div>
            <div class="content">
              <p>
                上から順に
                <ul>
                  <li>チャレンジリスト</li>
                  <li>アルバムリスト</li>
                  <li>応援リスト</li>
                </ul>

                が表示されています。
              </p>
              <p>各リストの右上のボタンで表示の切り替えができます。</p>
            </div>
            <div>
              <section class="item">
                <div>
                  <h2 class="title" id="home_challengesList">
                    <a href="#home_challengesList">チャレンジリスト</a>
                  </h2>
                </div>
                <div class="content">
                  <p>現在進行中のチャレンジが表示されています。</p>
                  <p>グラフには、「目標の達成度」「現在の更新ペース」「最終更新日」が表示されています。</p>
                  <p>プラスボタンからチャレンジの更新ができます。</p>
                  <p>タイトル部分をクリックするとチャレンジの詳細を見ることができます。</p>
                </div>
                <section class="item">
                  <div>
                    <h2 class="title" id="home_challengesList">
                      <a href="#rebase">チャレンジ設定</a>
                    </h2>
                  </div>
                  <div class="content">
                    <p>設定は
                      <ul>
                      <li>名前</li>
                      <li>目標期間または目標ペース</li>
                      <li>目標枚数</li>
                      <li>公開設定</li>
                    </ul>
                    の4つの項目があります。
                    </p>
                    <p>公開設定を非公開にすると、自分以外のユーザーに作成したチャレンジが表示されなくなります。</p>
                  </div>
                </section>
              </section>
              <section class="item">
                <div>
                  <h2 class="title" id="home_albumsList">
                    <a href="#home_albumsList">アルバムリスト</a>
                  </h2>
                </div>
                <div class="content">
                  <p>

                  過去に「完了した」または「期間が終了した」チャレンジが表示されています。
                  </p>
                  <p>
                    クリックするとアルバムの詳細を見ることができます。
                  </p>
                </div>
              </section>
              <section class="item">
                <div>
                  <h2 class="title" id="home_cheersLst">
                    <a href="#home_cheersLst">応援リスト</a>
                  </h2>
                </div>
                <div class="content">
                  <p>

                   応援リストに追加したチャレンジを見ることができます。
                  </p>
                  <p style="color: red">※現在は応援リストにチャレンジを追加することはできません</p>
                  <p>タイトル部分をクリックするとチャレンジの詳細を見ることができます。
                  </p>
                </div>
              </section>
            </div>
          </section>
          <section class="item">
            <div>
              <h2 class="title" id="cheer"><a href="#cheer">応援する</a></h2>
            </div>
            <div class="content">
              <p>
                他の人のチャレンジを見ることができます。
              </p>
              <p>※現在ランキング機能は実装されていません</p>
            </div>
          </section>
          <section class="item">
            <div>
              <h2 class="title" id="setting"><a href="#setting">設定</a></h2>
            </div>
            <div></div>
          </section>
          <section class="item">
            <div>
              <h2 class="title" id="setting_profile">
                <a href="#setting_profile">プロフィール設定</a>
              </h2>
            </div>
            <div class="content">
              <p>
                <ul>
                  <li>ユーザー画像</li>
                  <li>ユーザーネーム</li>
                  <li>プロフィール文</li>
                </ul>
                の設定ができます。
              </p>
            </div>
          </section>
          <section class="item">
            <div>
              <h2 class="title" id="setting_account">
                <a href="#setting_account">アカウント設定</a>
              </h2>
            </div>
            <div class="content">
              <p>アカウントの連携状態を確認することができます。</p>
              <p style="color: red;">※Twitter、Googleのいずれか片方のみを連携している場合は連携の解除ができません</p>
            </div>
          </section>
          <section class="item">
            <div>
              <h2 class="title" id="setting_account">
                <a href="#setting_account">ログアウト</a>
              </h2>
            </div>
            <div class="content">
              <p>「100mai」から一時的にログアウトすることができます。</p>
            </div>
          </section>
          <section class="item">
            <div>
              <h2 class="title" id="coin-mai">
                <a href="#coin-mai">アプリ内通貨「mai」</a>
              </h2>
            </div>
            <div class="content">
              <p>「mai」を使用して他の人のチャレンジを応援することができます。</p>
              <p>※現在ユーザー付与している「mai」は登録ボーナスの100枚のみとなっています</p>
            </div>
          </section>
          <section class="item">
            <div>
              <h2 class="title" id="character-mai">
                <a href="#character-mai"
                  >公式キャラクター「mai<span class="super">001</span>」</a
                >
              </h2>
            </div>
            <div class="content">
              <p>ポスターの女の子をご覧になったでしょうか？</p>
              <p>彼女は「100mai」の看板娘、「mai<span class="super">001</span>(マイゼロゼロイチ)」です。</p>
              <p>ファンアートなど歓迎しておりますので、可愛がっていただけると嬉しいです。</p>
              <p>※Twitterにて「#mai001」で公開されたものは感謝を込めてリツイートします。</p>
            </div>
          </section>
          <section class="item">
            <div>
              <h2 class="title" id="news"><a href="#news">更新情報など</a></h2>
            </div>
            <div class="content">
              <ul>
                <li>
                  2022/02/05 卒業制作作品として公開<br>
                  まだまだ実装が追いついていませんが、公開して実際に触っていただいても問題のないところまで仕上げられました。
                  近いうちに表示や仕様などを調整し、正式にリリースをしたいと考えています。
                </li>
              </ul>
            </div>
          </section>
          <section class="item">
            <div>
              <h2 class="title" id="contact">
                <a href="#contact">お問い合わせ</a>
              </h2>
            </div>
            <div class="content">
              <div class="form_wrapper">
                <label class="form_name">
                  <span>お名前またはTwitterID</span>
                  <span class="form_error" v-if="!form.name.length">入力してください</span>
                  <input id="contact_name" type="text" v-model="form.name" maxlength="50"/>
                </label>
                <!-- https://qiita.com/takeshisakuma/items/8c4efdcb1ba52f5e4ae9 -->
                <div class="form_checkbox">
                  <p>お問い合わせの種類</p>
                  <span class="form_error" v-if="!form.kind.length">選択してください</span>
                  <label>
                    <input type="checkbox" name="category" value="サイトの不具合" v-model="form.kind" />
                    <span>サイトの不具合</span>
                  </label>
                  <label>
                    <input type="checkbox" name="category" value="アカウントのトラブル" v-model="form.kind" />
                    <span>アカウントのトラブル</span>
                  </label>
                  <label>
                    <input type="checkbox" name="category" value="投稿された作品の通報" v-model="form.kind" />
                    <span>投稿された作品の通報</span>
                  </label>
                  <label>
                    <input type="checkbox" name="category" value="サイトに関する質問" v-model="form.kind" />
                    <span>サイトに関する質問</span>
                  </label>
                  <label>
                    <input type="checkbox" name="category" value="退会" v-model="form.kind" />
                    <span>退会</span>
                  </label>
                  <label>
                    <input type="checkbox" name="category" value="その他" v-model="form.kind" />
                    <span>その他</span>
                  </label>
                </div>
                <div class="form_radio">
                  <p>ご自身の評価する緊急度</p>
                  <label>
                    <input type="radio" value="3" name="urgency" v-model="form.urgency"/>
                    <span>高い</span>
                  </label>
                  <label>
                    <input type="radio" value="2" name="urgency" v-model="form.urgency"/>
                    <span>普通</span>
                  </label>
                  <label>
                    <input type="radio" value="1" name="urgency" v-model="form.urgency"/>
                    <span>低い</span>
                  </label>
                </div>
                <label class="form_about">
                  <span>件名：</span>
                  <span class="form_error" v-if="!form.about.length">入力してください</span>
                  <input maxlength="50" type="text" v-model="form.about"/>
                </label>
                <label class="form_textarea">
                  <span>詳しい内容</span>
                  <span class="form_error" v-if="!form.detail.length">入力してください</span>
                  <textarea id="contact_message" placeholder="" v-model="form.detail"></textarea>
                </label>
              </div>
              <div class="form_button">
                <button @click="sendInquiry('twitter')">twitterで送る</button>
                <button @click="sendInquiry('mail')">メールで送る</button>
              </div>

              <!-- <a class="button" href="https://twitter.com/messages/compose?recipient_id=1272867159048245249&ref_src=twsrc%5Etfw&text=【100maiについてのお問い合わせ】">お問い合わせ</a>
              <div class="text">TwitterのDMが<br>起動します</div> -->
            </div>
          </section>
        </div>
      </div>
    </main>
    <footer>
      <nav class="footer_nav">
        <ul>
          <li></li>
        </ul>
      </nav>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: "",
        kind: [],
        urgency: "1",
        about: "",
        detail: "",
      },
    };
  },
  mounted() {
    document.title = `About | 100mai`;
  },
  methods: {
    sendInquiry(form) {
      if (
        !this.form.name.length ||
        !this.form.kind.length ||
        !this.form.about.length ||
        !this.form.detail.length
      ) {
        return;
      }
      let text = `差出人: ${this.form.name}%0D%0A
      使用環境: ${navigator.userAgent}%0D%0A
      種類: ${this.form.kind.join()}%0D%0A
      緊急度: ${this.form.urgency}%0D%0A
      件名: ${this.form.about}%0D%0A
      内容: ${this.form.detail}`;
      console.log(form, text);
      if (form == "twitter") {
        window.open(
          `https://twitter.com/messages/compose?recipient_id=1272867159048245249&ref_src=twsrc%5Etfw&text=${text}`,
          "_blank"
        );
      } else if (form == "mail") {
        window.open(
          `mailto:service.100mai@gmail.com?subject=【${this.form.about}】&body=${text}`,
          "_blank"
        );
      }
    },
  },
};
</script>

<style lang="scss">
.about {
  @include fz(16);
  header {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    height: 58px;
    padding: 0 78px;
    transition: 0.3s;
    display: flex;
    align-items: center;
    justify-content: space-between;
    h1 {
      height: 58px;
      line-height: 1;
      display: flex;
      align-items: center;
      background-color: #fff;
      padding: 0 16px;
      img {
        height: 80%;
      }
    }
    a {
      height: 40px;
      padding: 0 16px;
      @include flex_c();
      background-color: #fff;
      box-shadow: $btn_shadow;
      border-radius: 20px;
      font-weight: 500;
      color: $main_orange;
    }
    @include about {
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    @include sp {
      padding: 0 4.5vw;
      justify-content: space-between;
    }
  }
  footer {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    height: 58px;
    padding: 0 78px;
    transition: 0.3s;
    display: flex;
    align-items: center;
    .contact {
      &_btn {
        display: flex;
        .button {
          height: 40px;
          padding: 0 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #f18d5f;
          border-radius: 4px;
          box-shadow: 1px 1px 4px #aaa;
        }
        .text {
          text-align: center;
          margin-left: 30px;
          @include fz(14);
          line-height: 1.1;
          position: relative;
          &::after {
            @include pseudo(100%, 30px);
            background-image: url("./../assets/svg/roll.svg");
            background-size: contain;
            left: -34px;
            bottom: -2px;
            transform: rotate(20deg);
          }
        }
      }
    }
    @include about {
      padding: 0;
      justify-content: center;
    }
  }
  main {
    padding: 58px;
    height: 100vh;
    width: 100vw;
    line-height: 2;
    p {
      margin: 1em;
    }
    .holder {
      height: 100%;
      width: 100%;
      box-shadow: inset 0px 0px 8px #aaa;
    }
    .scroll {
      height: 100%;
      overflow-y: scroll;
      padding-bottom: 120px;
    }
    .item {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      padding: 0 20px;
      & > div {
        min-width: 60%;
      }
      .title {
        margin-top: 60px;
        @include fz(24);
        a {
          font-weight: 500;
          @include fz(20);
        }
      }
      .index {
        @include fz(18);
        margin-top: 60px;
        text-align: left;
        padding: 20px;
        background-color: $bg_accent;
        li {
          margin-bottom: 10px;
          a {
            border-bottom: 1px solid #000;
          }
        }
        .drop {
          margin-left: 9px;
          padding-left: 9px;
          border-left: 1px solid #000;
        }
      }
      .super {
        vertical-align: super;
        @include fz(14);
      }
      .content {
        background-color: #fff;
        width: 100%;
        padding: 20px;
        ul {
          padding-left: 30px;
        }
        li {
          list-style-type: disc;
          text-align: left;
        }
      }
    }
    .form {
      &_name,
      &_about,
      &_textarea {
        span {
          margin: 1em;
          display: inline-block;
          width: 100%;
          text-align: left;
          font-weight: 300;
          @include fz(18);
          &.form_error {
            margin: 0;
            margin-left: 1em;
            @include fz(14);
            color: red;
            font-weight: 500;
          }
        }
        input,
        textarea {
          width: 100%;
          margin: 0 1em;
          padding: 2px 10px;
          border-radius: 4px;
          border: 2px solid $main_orange;
        }
        textarea {
          min-height: 120px;
        }
      }
      &_checkbox,
      &_radio {
        display: flex;
        flex-direction: column;
        text-align: left;
        label {
          padding-left: 2em;
          border-radius: 4px;
          @include pc() {
            &:hover {
              background-color: $bg_accent;
            }
          }
        }
      }
      &_error {
        margin: 0;
        margin-left: 2em;
        @include fz(14);
        color: red;
      }
      &_button {
        width: 100%;
        margin-top: 60px;
        button {
          background-color: $bg_accent;
          width: 50%;
          padding: 10px 0;
          @include pc() {
            &:hover {
              background-color: $main_orange;
            }
          }
        }
      }
    }
    @include about {
      padding: 58px 0;
      .item {
      }
    }
  }
}
</style>